import { Card, CardContent, View, Image, Skeleton } from "@/components/ui";
import { CaretRight } from "@/components/shared/icons";
import { useRoute } from "@/components/shared/router";
import { useAuthState } from "@/store/auth";
import { Typography } from "@/components/shared/typography";
import { useAvailableClientVouchersStore } from "@/store/invoices/useAvailableClientVouchers";
import { useEffect } from "react";
import PromoTagIcon from "@/assets/images/3d-icons/promo-tag.png";

export const MyVoucher = () => {
  const { push } = useRoute();
  const {
    data: { userInfo },
  } = useAuthState();
  const {
    fetch: getVouchers,
    data,
    loading,
  } = useAvailableClientVouchersStore();
  useEffect(() => {
    if (userInfo.id) {
      getVouchers({
        requestPayload: {
          clientId: userInfo.id,
        },
      });
    }
  }, [userInfo.id, getVouchers]);
  const handleGotoRewardList = () => {
    push({
      pageKey: "myVouchers",
    });
  };
  if (loading) {
    return (
      <Card border="none" className="flex-1">
        <CardContent className="flex flex-col gap-2 px-3 py-2">
          <View className="flex flex-row items-start justify-between">
            <Skeleton className="h-8 w-8 rounded-lg" />
          </View>
          <View>
            <View className="flex flex-row items-center justify-between gap-1">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-4 w-4 rounded-full" />
            </View>
            <Skeleton className="mt-1 h-4 w-16" />
          </View>
        </CardContent>
      </Card>
    );
  }
  return (
    <Card
      border="none"
      className="flex-1 cursor-pointer"
      onClick={handleGotoRewardList}
    >
      <CardContent className="flex flex-col gap-2 px-3 py-2">
        <View className="flex flex-row items-start justify-between">
          <Image src={PromoTagIcon} width={32} height={32} />
        </View>
        <View>
          <View className="flex flex-row items-center justify-between gap-1">
            <Typography variant="caption-md" color="foreground-intermediate">
              My Voucher
            </Typography>
            <CaretRight size={16} className="text-foreground-attenuated" />
          </View>
          <Typography color="brand-primary" variant="label-sm">
            {`${data?.length || 0} Active`}
          </Typography>
        </View>
      </CardContent>
    </Card>
  );
};
